<template>
    <div class="loading-page" style="position: absolute;top:0;right:0;bottom:0;left:0;">
        <div style="height: 167px;">
            <Spin fix>
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>上传中...</div>
            </Spin>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // isShow: {
        //     type: Boolean,
        //     default: true,
        // },
    },
};
</script>

<style scoped>
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.loading-page {
    border: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/PicLoading.vue